const projectType = {
  CREATE_PROJECT: "CREATE_PROJECT",
  CREATE_PROJECT_COMMIT: "CREATE_PROJECT_COMMIT",
  CREATE_PROJECT_ROLLBACK: "CREATE_PROJECT_ROLLBACK",

  RESET_PROJECT: "RESET_PROJECT",
};
  
  export default projectType;